import ReactDOM from "react-dom/client";
import "react-toastify/dist/ReactToastify.css";
import "react-loading-skeleton/dist/skeleton.css";
import "./index.css";
import "./config/i18n";
import AppWithProviders from "./AppWithProviders.jsx";

import { reloadOnceOnChunkLoadError } from "./helpers/chunkLoadError";

// Recover from stale cached HTML pointing at missing hashed chunks.
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  reloadOnceOnChunkLoadError();
});

async function enableMockMode() {
  const useDashboardMocks =
    import.meta.env.DEV &&
    import.meta.env.VITE_USE_DASHBOARD_MOCKS === "true";
  if (!useDashboardMocks) return;

  const { worker } = await import("./mocks/browser");
  await worker.start({
    onUnhandledRequest: "bypass",
  });
}

async function bootstrap() {
  await enableMockMode();
  ReactDOM.createRoot(document.getElementById("root")).render(
    <AppWithProviders />
  );
}

bootstrap();
